import { useEffect, useState } from 'react';
import { memberApi } from '@formosa/shared/api/member';
import { DEFAULT_REGISTER_CONFIG } from '@formosa/shared/utils/registerConfig';

export function useRegisterConfig() {
  const [registerConfig, setRegisterConfig] = useState(DEFAULT_REGISTER_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    memberApi
      .getRegisterConfig()
      .then((config) => {
        if (!cancelled) setRegisterConfig(config);
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { registerConfig, loading };
}
